export type Envs<T> = Record<BUILD_ENV, T>

export default class BuildUtils {
  public static _buildEnvColors: Record<Exclude<BUILD_ENV, 'prod'>, string> = {
    local: 'rgba(127,127,127,1)',
    int: 'rgba(240,163,18,1)',
    stage: 'rgba(240,38,18,1)',
  }

  public static isProduction(): boolean {
    return process.env.NEXT_PUBLIC_APP_ENV === 'prod'
  }

  public static isStage(): boolean {
    return process.env.NEXT_PUBLIC_APP_ENV === 'stage'
  }

  public static isIntegrate(): boolean {
    return process.env.NEXT_PUBLIC_APP_ENV === 'int'
  }

  public static getEnvName(): string {
    return process.env.NEXT_PUBLIC_APP_ENV ?? 'local'
  }

  public static getEnvColor(): string {
    return BuildUtils._buildEnvColors[process.env.NEXT_PUBLIC_APP_ENV ?? 'local']
  }

  public static getValue<T>(envs: Envs<T>): T {
    return envs[process.env.NEXT_PUBLIC_APP_ENV ?? 'local'] ?? envs['local']
  }
}
